import React from 'react';
import { MapPin, Clock, Phone, Mail } from 'lucide-react';
import './Location.css';
import { trackEvent } from '../lib/analytics';
import { useBusinessHours, DAY_ORDER, DAY_LABELS, formatDayHours } from '../lib/businessHours';

const Location = () => {
  const businessHours = useBusinessHours();

  return (
    <section id="location" className="location-section">
      <div className="location-container">
        <div className="location-header">
          <h2 className="section-title">Visit Us</h2>
          <p className="section-subtitle">859 Belmont Ave SW #120, Albany, Oregon</p>
        </div>

        <div className="location-content">
          <div className="location-info">
            <div className="info-card dark-hover">
              <div className="info-icon">
                <MapPin size={32} />
              </div>
              <h3 className="info-title">Address</h3>
              <p className="info-text">859 Belmont Ave SW #120</p>
              <p className="info-text">Albany, OR 97321</p>
              <a 
                href="https://maps.google.com/?q=859+Belmont+Ave+SW+%23120+Albany+OR+97321" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-secondary dark-button-animate"
              >
                Get Directions
              </a>
            </div>

            <div className="info-card dark-hover">
              <div className="info-icon">
                <Clock size={32} />
              </div>
              <h3 className="info-title">Hours</h3>
              {businessHours && DAY_ORDER.map((key) => (
                <div key={`hours-${key}`} className="hours-row" data-testid={`location-hours-${key}`}>
                  <span className="hours-day">{DAY_LABELS[key]}</span>
                  <span className="hours-time" data-testid={`location-hours-time-${key}`}>{formatDayHours(businessHours[key])}</span>
                </div>
              ))}
            </div>

            <div className="info-card dark-hover">
              <div className="info-icon">
                <Phone size={32} />
              </div>
              <h3 className="info-title">Contact</h3>
              <p className="info-text">
                <a href="tel:+14582534058" className="contact-link" onClick={() => trackEvent('phone_click', { link_location: 'location' })}>(458) 253-4058</a>
              </p>
              <div className="info-icon" style={{ marginTop: '20px' }}>
                <Mail size={32} />
              </div>
              <p className="info-text">
                <a href="mailto:novumventuresholdings@gmail.com" className="contact-link">novumventuresholdings@gmail.com</a>
              </p>
            </div>
          </div>

          <div className="map-container">
            <iframe
              title="Royal Bar & Grill Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2877.5!2d-123.105!3d44.625!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x54c0a5b5b5b5b5b5%3A0x0!2s859+Belmont+Ave+SW%2C+Albany%2C+OR+97321!5e0!3m2!1sen!2sus!4v1234567890123"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;